import React, { useState } from "react";
import './Contactus.css';
import Footer from '../Footer/Footer';
import PropertiesService from "../../Services/PropertiesService";
import { MapPin, Mail, Phone, Clock } from 'lucide-react';

const Contactus = () => {
    const initialFormState = {
        firstName: "",
        lastName: "",
        email: "",
        contact: "",
        address: "",
        message: "",
    };
    const [Error, setError] = useState([])
    const [formData, setFormData] = useState(initialFormState);
    const [submitMessage, setSubmitMessage] = useState('');
    const [ErrorMessage, setErrorMessage] = useState('');

    const handleChange = (e) => {
        const { name } = e.target;
        let value = e.target.value;

        if (name === 'email') {
            value = value.replace(/\s/g, '');
        }

        if (name === 'contact') {
            value = value.replace(/\D/g, '').slice(0, 10);
        }

        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));

        if (!value.trim()) {
            setError((prevError) => ({
                ...prevError,
                [name]: `Please enter ${getReadableFieldName(name)}.`
            }));
        } else {
            setError((prevError) => ({
                ...prevError,
                [name]: ""
            }));
        }
    };

    const getReadableFieldName = (name) => {
        const map = {
            firstName: "your first name",
            lastName: "your last name",
            email: "your email address",
            address: "your address",
            message: "a message",
            contact: "your contact number",
        };
        return map[name] || name;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const { firstName, lastName, email, address, message, contact } = formData;

        if (!firstName?.trim()) {
            setError({ firstName: 'Please enter your first name.' })
            return;
        }
        else if (!lastName?.trim()) {
            setError({ lastName: 'Please enter your last name.' })
            return;
        }
        else if (!email?.trim()) {
            setError({ email: 'Please enter your email address.' })
            return;
        }
        else if (!address?.trim()) {
            setError({ address: 'Please enter your address.' })
            return;
        }
        else if (contact?.trim().length > 0 && contact?.trim().length !== 10) {
            setError({ contact: 'Contact number must be 10 digits' })
            return;
        }
        else if (!message?.trim()) {
            setError({ message: 'Please enter a message.' })
            return;
        }
        else if (!emailRegex.test(email?.trim())) {
            setError({ email: 'Please enter a valid email address.' })
            return;
        }
        else {
            try {
                const response = await PropertiesService.saveContactUsDetails(formData);
                if (response.message === 'Success') {
                    setFormData(initialFormState);
                    setSubmitMessage('Your message was sent successfully!');
                    setTimeout(() => {
                        setSubmitMessage('')
                    }, 2000)
                } else {
                    setTimeout(() => {
                        setSubmitMessage('')
                    }, 2000)
                    setErrorMessage('something went wrong! please try again')
                }
            } catch (error) {
                console.error("Error submitting form:", error);
                alert("An error occurred. Please try again later.");
            }
        }
    };

    const handleMobileChange = (e) => {
        const value = e.target.value;
        setFormData({ ...formData, contact: value });
        if (value.length !== 10) {
            setError({ ...Error, contact: "Phone number should be 10 digits" });
        } else {
            setError({ ...Error, contact: "" });
        }
    };

    return (
        <div className="ds-marketing contact-page">
            <div className="contact-content-wrapper">
                
                {/* Header Banner */}
                <div className="contact-header-section">
                    <h1 className="contact-page-title">Contact Us</h1>
                    <p className="contact-page-subtitle">We are here to assist you with your property verification journey.</p>
                </div>

                <div className="contact-grid-container">
                    
                    {/* Left Column: Info Cards */}
                    <div className="contact-info-column">
                        <div className="info-card">
                            <div className="info-icon-container">
                                <MapPin size={20} />
                            </div>
                            <div className="info-card-content">
                                <h3>Our Office</h3>
                                <p>DoCity Consultancy Services</p>
                                <p>Hyderabad, Telangana, India</p>
                            </div>
                        </div>

                        <div className="info-card">
                            <div className="info-icon-container">
                                <Mail size={20} />
                            </div>
                            <div className="info-card-content">
                                <h3>Email Support</h3>
                                <p>support@docity.co.in</p>
                                <p>info@docity.co.in</p>
                            </div>
                        </div>

                        <div className="info-card">
                            <div className="info-icon-container">
                                <Phone size={20} />
                            </div>
                            <div className="info-card-content">
                                <h3>Phone Assistance</h3>
                                <p>+91 90000 12345</p>
                                <p>Mon - Sat, 9am - 6pm</p>
                            </div>
                        </div>

                        <div className="info-card">
                            <div className="info-icon-container">
                                <Clock size={20} />
                            </div>
                            <div className="info-card-content">
                                <h3>Business Hours</h3>
                                <p>Monday to Saturday</p>
                                <p>09:00 AM to 06:00 PM</p>
                            </div>
                        </div>
                    </div>

                    {/* Right Column: Form */}
                    <div className="contact-form-column">
                        <div className="contact-form-card">
                            <h2 className="contact-form-title">Send Us a Message</h2>
                            <p className="contact-form-subtitle">Fill out the form below and our team will get back to you within 24 hours.</p>
                            
                            <form onSubmit={(e) => e.preventDefault()}>
                                <div className="contact-form-row">
                                    <div className="contact-form-group">
                                        <label htmlFor="firstName">First Name</label>
                                        <input
                                            type="text"
                                            id="firstName"
                                            name="firstName"
                                            value={formData.firstName}
                                            onChange={handleChange}
                                            placeholder="Enter first name"
                                            className="contact-field"
                                            required
                                        />
                                        {Error && Error?.firstName && <span className="error-text">{Error.firstName}</span>}
                                    </div>

                                    <div className="contact-form-group">
                                        <label htmlFor="lastName">Last Name</label>
                                        <input
                                            type="text"
                                            id="lastName"
                                            name="lastName"
                                            value={formData.lastName}
                                            onChange={handleChange}
                                            placeholder="Enter last name"
                                            className="contact-field"
                                            required
                                        />
                                        {Error && Error?.lastName && <span className="error-text">{Error.lastName}</span>}
                                    </div>
                                </div>

                                <div className="contact-form-group">
                                    <label htmlFor="email">Email Address</label>
                                    <input
                                        type="text"
                                        id="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder="johndoe@example.com"
                                        className="contact-field"
                                        required
                                    />
                                    {Error && Error?.email && <span className="error-text">{Error.email}</span>}
                                </div>

                                <div className="contact-form-group">
                                    <label htmlFor="contact">Phone Number (Optional)</label>
                                    <input
                                        type="tel"
                                        id="contact"
                                        name="contact"
                                        value={formData.contact}
                                        onChange={handleMobileChange}
                                        placeholder="Enter phone number"
                                        className="contact-field"
                                    />
                                    {Error && Error?.contact && <span className="error-text">{Error.contact}</span>}
                                </div>

                                <div className="contact-form-group">
                                    <label htmlFor="address">Address</label>
                                    <textarea
                                        id="address"
                                        name="address"
                                        value={formData.address}
                                        onChange={handleChange}
                                        placeholder="Enter your address here"
                                        rows="3"
                                        className="contact-field"
                                        required
                                    />
                                    {Error && Error?.address && <span className="error-text">{Error.address}</span>}
                                </div>

                                <div className="contact-form-group">
                                    <label htmlFor="message">Message</label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        placeholder="Type your message here"
                                        rows="4"
                                        className="contact-field"
                                        required
                                    />
                                    {Error && Error?.message && <span className="error-text">{Error.message}</span>}
                                </div>

                                <button
                                    type="submit"
                                    className="contact-submit-action-btn"
                                    onClick={handleSubmit}>
                                    Send message
                                </button>
                                
                                {submitMessage && <p className="contact-success-alert">{submitMessage}</p>}
                                {ErrorMessage && <p className="contact-error-alert">{ErrorMessage}</p>}
                            </form>
                        </div>
                    </div>

                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Contactus;

